import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAttrs } from 'vue';
import ITextField from './ITextField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ITextArea',
  props: /*@__PURE__*/_mergeModels({
    name: {},
    title: { default: '' },
    rules: { default: '' },
    autocomplete: { default: undefined }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const innerValue = _useModel<string | number>(__props, "modelValue");
const attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ITextField, _mergeProps({
    modelValue: innerValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    name: _ctx.name,
    type: "textarea",
    title: _ctx.title,
    rules: _ctx.rules,
    autocomplete: _ctx.autocomplete
  }, _unref(attrs)), {
    help: _withCtx(() => [
      _renderSlot(_ctx.$slots, "help")
    ]),
    _: 3
  }, 16, ["modelValue", "name", "title", "rules", "autocomplete"]))
}
}

})